import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Id } from "@/convex/_generated/dataModel";
import ServiceForm from "@/components/services/service-form";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute(
  "/_authenticated/services/_layout/$id/edit",
)({
  component: EditServicePage,
});

function EditServicePage() {
  const { id } = Route.useParams();

  const service = useQuery(api.companies.services.queries.getService, {
    id: id as Id<"services">,
  });

  if (service === undefined) {
    return (
<RouteGuardPermissions
      permissions={[{ module: "services", actions: ["read", "update"] }]}>
      
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    
    </RouteGuardPermissions>
    );
  }

  if (service === null) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">Servicio no encontrado</p>
      </div>
    );
  }

  return <ServiceForm service={service} />;
}
